import styled from 'styled-components';
import { FormHelperText } from '@mui/material';
import { theme } from '../../styles/theme';
export const Wrapper = styled(FormHelperText) `
  && {
    ${theme.typography.bodyMD};
    color: ${theme.colors.textTertiary};
    margin: ${theme.spacing.xxs} 0 0;
  }
`;
